/**
 * tdesign v0.46.2
 * (c) 2022 tdesign
 * @license MIT
 */

import Popup$1 from './popup.js';
import mapProps from '../utils/map-props.js';
import { withInstall } from '../utils/withInstall.js';
import './style/css.js';
import './type.js';
import '@babel/runtime/helpers/typeof';
import '@babel/runtime/helpers/defineProperty';
import '@popperjs/core';
import '../utils/dom.js';
import 'vue';
import 'raf';
import 'lodash/isString';
import '../utils/easing.js';
import '../utils/render-tnode.js';
import 'lodash/camelCase';
import 'lodash/kebabCase';
import '../utils/helper.js';
import '@babel/runtime/helpers/objectWithoutProperties';
import '@babel/runtime/helpers/slicedToArray';
import '../_common/js/utils/set-style.js';
import './props.js';
import './container.js';
import '../config-provider/config-receiver.js';
import 'lodash/mergeWith';
import '../config-provider/context.js';
import 'lodash/merge';
import '../_common/js/global-config/default-config.js';
import '../_common/js/global-config/locale/zh_CN.js';
import '../config-provider/type.js';
import '../utils/mixins.js';
import 'lodash/capitalize';

var Popup = withInstall(mapProps(["visible"], {
  model: {
    prop: "visible",
    event: "visible-change"
  }
})(Popup$1));

export { Popup, Popup as default };
//# sourceMappingURL=index.js.map
